// import axios from '../plugins/axios'
const state = {
  selected_alphabet : '',
  alphabets: [],
}
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key]
  }
}
const  actions = {

}
const mutations = {
  setData(state,data){
    state[data.key] = data.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}